<template>
  <div
    class="title_container"
    :style="{alignItems: alignItems, height: height}"
  >
    <div class="zh" :style="{fontSize: fontSizeZh, color: colorZh}">
      {{ zh }}
    </div>
    <div class="line" :style="{backgroundColor: colorLine}"></div>
    <div class="en" :style="{color: colorEn}">
      {{ en }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'JsTitle',
  props: {
    zh: String,
    en: String,
    alignItems: {
      type: String,
      default: 'center'
    },
    fontSizeZh: {
      type: String,
      default: '36px'
    },
    height: {
      type: String,
      default: '180px'
    },
    colorZh: {
      type: String,
      default: '#00439a'
    },
    colorEn: {
      type: String,
      default: '#333333'
    },
    colorLine: {
      type: String,
      default: '#00439a'
    }
  }
}
</script>

<style lang="scss" scoped>
.title_container {
  line-height: 28px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .zh {
    margin-bottom: 23px;
  }
  .line {
    width: 50px;
    height: 6px;
  }
  .en {
    font-size: 16px;
  }
}
</style>
